import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=8088f272&scoped=true"
import script from "./SimpleForm.vue?vue&type=script&lang=ts"
export * from "./SimpleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8088f272",
  null
  
)

export default component.exports